import * as type from '../actions/types';

const initialState = {
  data: [],
  fetching: false,
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_COMPLETED_CHANGE_REQUESTS_PENDING: {
      return {
        ...initialState,
        fetching: true,
      };
    }

    case type.FETCH_COMPLETED_CHANGE_REQUESTS_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        fetching: false,
      };
    }

    case type.FETCH_COMPLETED_CHANGE_REQUESTS_FAILURE: {
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };
    }

    default: {
      return state;
    }
  }
};
